module.exports = [
	{
		"image": "2XLuXlMT0Q1nPlzuVhpgGpbjI9wEFNPk1498936721-min.jpg",
		"username": "Martynas Justinevicius",
		"spot": "Solstugans Terrass"
	},
	{
		"image": "5g5HEFmQpgumRE9LhH9IirfCNLVCjXfB1499887943-min.jpg",
		"username": "Elin Strååt",
		"spot": "Skinnarviksberget"
	},
	{
		"image": "A2JHugzCRAXr5w6BAPT546MmYXLIxYVa1499961833-min.jpg",
		"username": "Josefin Bergman",
		"spot": "Brunkebergstunneln"
	},
	{
		"image": "afga1CSS0K3cqS8xk0uBLUPZfFzaQo781499004790-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Fjällgatan"
	},
	{
		"image": "bMfJcALHrvK44ngmmKSYjIOX6WK009OB1501659382-min.jpg",
		"username": "Fredrik Stene",
		"spot": "Kungliga Biblioteket"
	},
	{
		"image": "BGyTlEWfS1u2sY8RG8keVbED7MTNCiK61501532811-min.jpg",
		"username": "Anette Bothin",
		"spot": "Kungsgatan"
	},
	{
		"image": "DcezCfQaEQDXJ2u6T50fTOEM2devy2eS1500587198-min.jpg",
		"username": "Patrik Renström",
		"spot": "Västerbron"
	},
	{
		"image": "do2xr4BvhlUTn6TmtoB54vuC5Sl2AS901501744361-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Bastugatan - Bellmansgatan"
	},
	{
		"image": "Gwr7vjNZq5BNMWTtCY7olHQNOAP0HHBG1500009940-min.jpg",
		"username": "Josefin Bergman",
		"spot": "Hornsbergs strandpark"
	},
	{
		"image": "KNtk4IrMva9gFkpcMsknmETc0lgrNEjA1499876690-min.jpg",
		"username": "Elin Strååt",
		"spot": "Bastugatan - Bellmansgatan"
	},
	{
		"image": "OIdodTT8zm43LNJKYX1h6I3psz2Su8Kz1501273716-min.jpg",
		"username": "Albin Per Hans Ulvebring",
		"spot": "Kastellparken"
	},
	{
		"image": "OZ6OfYSeLNPcAa8laAYqQnJle4U1kjOi1501743072-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Skinnarviksberget"
	},
	{
		"image": "Q8ui7toOjfEDSkUa841szwchOTpf3EIO1501270954-min.jpg",
		"username": "Albin Per Hans Ulvebring",
		"spot": "Blasieholmen"
	},
	{
		"image": "rrOZKEuaskUem7ndr9LrrDYUbYTxr6Rt1499284033-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Berzeeli Park - Nybroviken"
	},
	{
		"image": "sAtE1weUEN3ql85YXbV8yzVJKl7dXxia1500575632-min.jpg",
		"username": "Patrik Renström",
		"spot": "Monteliusvägen"
	},
	{
		"image": "Syh5Bv1mgj2Jewj3ZRw31CG20Ov7wM3o1500565150-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Kungliga Biblioteket"
	},
	{
		"image": "trSqDjgKv63FuhN4uTEjWyGMs2gPwAYE1499107981-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Trädgård på Spåret"
	},
	{
		"image": "vE8YoXYzQjOCaMrm9BWovUiTgD7xn7wW1501101870-min.jpg",
		"username": "Patrik Renström",
		"spot": "Södra Brobänken"
	},
	{
		"image": "wDMN4Z15VocSj5tBTVVQn9LB0wzxOr291501528306-min.jpg",
		"username": "Enna Pü",
		"spot": "Kastellparken"
	},
	{
		"image": "zHzeHZlW36AQICk2p3RUAglZpjDP1KV91499863690-min.jpg",
		"username": "Elin Strååt",
		"spot": "Bondegatan"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/json/thend.json
// module id = 130
// module chunks = 0